module.exports = __webpack_public_path__ + "img/py.pyf95e744.svg";